import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { InitialDataResolver } from './app.resolvers';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { NoAuthGuard } from './core/auth/guards/no-auth.guard';
import { LayoutComponent } from './layout/layout.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '1' },
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: '1' },
  {
    path: '',
    canActivate: [AuthGuard],
    resolve: {
      initialData: InitialDataResolver,
    },
    loadChildren: () => import('./tabs/tabs-routing').then((m) => m.routes),
  },
  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'forgot-password',
        loadComponent: () => import('./pages/auth/forgot-password/forgot-password.page').then((m) => m.ForgotPasswordPage),
      },
      // {
      //   path: 'reset-password',
      //   loadComponent: () => import('./pages/auth/reset-password/reset-password.page').then((m) => m.ResetPasswordPage),
      // },
      {
        path: 'sign-in',
        loadComponent: () => import('./pages/auth/sign-in/sign-in.page').then((m) => m.SignInPage),
      },
      {
        path: 'agree-terms/:email',
        loadComponent: () => import('./pages/terms/terms.page').then((m) => m.TermsPage),
      },
    ],
  },

  // Auth routes for authenticated users
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    // component: LayoutComponent,
    // data: {
    //   layout: 'empty',
    // },
    children: [
      {
        path: 'add-active',
        loadComponent: () => import('./pages/add-active/add-active.page').then((m) => m.AddActivePage),
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.page').then((m) => m.ProfilePage),
      },
      {
        path: 'sign-out',
        loadComponent: () => import('./pages/auth/sign-out/sign-out.page').then((m) => m.SignOutPage),
      },
      {
        path: 'unlock-session',
        loadComponent: () => import('./pages/auth/unlock-session/unlock-session.page').then((m) => m.UnlockSessionPage),
      },
      {
        path: 'reset-password', 
        loadComponent: () => import('./pages/auth/reset-password/reset-password.page').then((m) => m.ResetPasswordPage)
      },
      {
        path: 'market',
        loadComponent: () => import('./pages/market/market.page').then((m) => m.MarketPage),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
